import { message, ToastMessage } from "../../../scripts/models/message.model";
import {
  getAllProps,
  getRequiredComponentElements,
} from "../../../scripts/utils/utility";
import * as styles from "bundle-text:./toast_component.scss";

export class ToastComponent extends HTMLElement {
  private _message: ToastMessage | null = null;
  private props: Map<string, string>;
  private propNames = {
    dataShow: "data-show",
    dataHide: "data-hide",
  };
  private template = () => `
   <style>${styles}</style>
   <div class="toast-container">
   <div class="toast" ></div>
   </div>`;

  static get observedAttributes() {
    return ["data-show"];
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.props = getAllProps(this);
    this.render();
  }

  public get message(): ToastMessage | null {
    return this._message;
  }
  public set message(value: ToastMessage | null) {
    this._message = value;
  }

  private initializeToastMessage() {
    const element = this.shadowRoot?.querySelector(".toast") as HTMLElement;
    console.log(this.message);
    if (this.message && this.message.type && this.message.text) {
      element?.classList.add(this.message.type);
      element.textContent = this.message.text;
    } else {
      console.log("failed to initialize toast message ", this.message);
    }
  }
  connectedCallback() {
    this.initializeToastMessage();
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === this.propNames.dataShow) {
      const element = this.shadowRoot?.querySelector(".toast");
      element?.classList.add("show");
    }
    if (name === this.propNames.dataHide) {
      const element = this.shadowRoot?.querySelector(".toast");
      element?.classList.remove("show");
    }
  }

  render() {
    if (this.shadowRoot) {
      this.shadowRoot.innerHTML = this.template().trim();
    }
  }
}

customElements.define("toast-component", ToastComponent);
